import React from 'react';
import PropTypes from 'prop-types';

const Form = ({ children, ...props }) => (
  <form {...props}>
    {children}
    <input type="submit" style={{ display: 'none' }} />
  </form>
);

Form.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Form;
